import produce from 'immer';

// TYPES
import { Types, ExcluirPerfil } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: ExcluirPerfil = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirPerfil {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_PERFIL: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_PERFIL_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_PERFIL_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_PERFIL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
